import React, { Fragment, useContext, memo } from 'react'
import {
  TableBody as MuiTableBody,
  TableRow,
  Checkbox,
  Collapse,
  TableCell,
  makeStyles,
  lighten,
  Typography,
  darken,
  CircularProgress,
} from '@material-ui/core'
import clsx from 'clsx'
import { isArray } from 'lodash'
import { TableContext } from '../Table/Table'
import translations from '../../translations'


const useStyles = makeStyles((theme) => ({
  hover: {
    '&:hover':
      theme.palette.type === 'light'
        ? {
            backgroundColor: `${lighten(theme.palette.secondary.light, 0.85)} !important`,
          }
        : {
            backgroundColor: `${darken(theme.palette.secondary.dark, 0.3)} !important`,
          },
  },
  open:
    theme.palette.type === 'light'
      ? {
          backgroundColor: `${lighten(theme.palette.primary.light, 0.85)} !important`,
          '&:hover': {
            backgroundColor: `${lighten(theme.palette.primary.light, 0.75)} !important`,
          },
        }
      : {
          backgroundColor: `${lighten(theme.palette.primary.dark, 0.2)} !important`,
          '&:hover': {
            backgroundColor: `${lighten(theme.palette.primary.dark, 0.3)} !important`,
          },
        },
  semDados: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    fontSize: '1rem',
  },
  group: {
    '&>td': {
      padding: '0px',
      // '&:hover':{
      //   backgroundColor: theme.palette.action.selected
      // }
    },
  },
  loading: {
    textAlign: 'center',
    padding: '7px',
  },
}))

// eslint-disable-next-line react/display-name
const TableBody = memo(
  ({
    children,
    line,
    lineStyle,
    handleOpenClose,
    lineClass,
    enableCheck,
    disableCheckIf,
    columnStyles,
    head,
    onClick,
    indexToSelect,
    open,
    dadosMostrados,
    columnOptions,
    lineTitle,
    customKey,
    columnProps,
  }) => {
    const classes = useStyles()

    const t = translations[navigator.language.split('-')[0].toUpperCase()] || translations['PT'];
    const { lista, selected, dispatch, loading } = useContext(TableContext)

    const handleClick = (name) => {
      const selectedIndex = selected.indexOf(name)
      let newSelected = []
      if (selectedIndex === -1) newSelected = newSelected.concat(selected, name)
      else if (selectedIndex === 0)
        newSelected = newSelected.concat(selected.slice(1))
      else if (selectedIndex === selected.length - 1)
        newSelected = newSelected.concat(selected.slice(0, -1))
      else if (selectedIndex > 0)
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        )
      dispatch({ type: 'setSelected', value: newSelected })
    }

    const isSelected = (name) => selected.indexOf(name) !== -1

    const getCellContent = (coluna, linha, index, i) => {
      if (columnOptions) {
        const item = columnOptions.filter((item) => item.alias === index)
        if (item.length > 0)
          return item[0].customJsx({
            index: i,
            itemFormatado: line(linha)[index],
            linhaFormatada: line(linha),
            linhaOriginal: linha,
          })
      }
      return coluna
    }

    return (
      <MuiTableBody>
        {loading ? (
          <TableRow>
            <TableCell
              className={classes.loading}
              colSpan={head.length + (enableCheck ? 1 : 0)}
            >
              <CircularProgress disableShrink />
            </TableCell>
          </TableRow>
        ) : dadosMostrados.length ? (
          dadosMostrados.map((linha, i) => {
            const isItemSelected = isSelected(linha[indexToSelect])
            const isItemOpen = i === open
            return (
              <Fragment key={customKey ? lista[i][customKey] : i}>
                <TableRow
                  className={clsx({
                    [classes.hover]: isItemSelected,
                    [classes.open]: isItemOpen && children && !onClick,
                    [lineClass(line(linha), linha, i)]: true,
                  })}
                  hover
                  title={lineTitle}
                  role="checkbox"
                  tabIndex={-1}
                  selected={isItemSelected}
                  style={
                    lineStyle ? lineStyle(linha, line(linha), i) : undefined
                  }
                  onClick={
                    onClick
                      ? (e) => onClick(e, linha, line(linha), i)
                      : children
                        ? () => handleOpenClose(i)
                        : undefined
                  }
                >
                  {enableCheck && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        disabled={
                          disableCheckIf &&
                          disableCheckIf(linha, line(linha), i)
                        }
                        onClick={(e) => {
                          e.stopPropagation()
                          handleClick(linha[indexToSelect])
                        }}
                        checked={isItemSelected}
                      />
                    </TableCell>
                  )}
                  {isArray(line(linha)) &&
                    line(linha).map((coluna, j) => (
                      <TableCell
                        key={j}
                        style={columnStyles ? columnStyles[j] : undefined}
                        {...columnProps(j, coluna)}
                      >
                        {getCellContent(coluna, dadosMostrados[i], j, i)}
                      </TableCell>
                    ))}
                </TableRow>
                {children && (
                  <TableRow className={classes.group}>
                    <TableCell
                      colSpan={head.length + (enableCheck ? 1 : 0)}
                      style={{ padding: open === i ? 8 : 0 }}
                    >
                      <Collapse in={open === i} mountOnEnter unmountOnExit>
                        {typeof children === 'function'
                          ? children({
                              linha: line(linha),
                              linhaOriginal: linha,
                              index: i,
                            })
                          : children}
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </Fragment>
            )
          })
        ) : (
          <TableRow>
            <Typography
              className={classes.semDados}
              component="td"
              variant="h6"
              colSpan={head.length + (enableCheck ? 1 : 0)}
            >
             {t.vazio}
            </Typography>
          </TableRow>
        )}
      </MuiTableBody>
    )
  },
)

export default TableBody
